<template>
  <el-dialog :title="'询盘详情'" :visible.sync="dialogTableVisible" :before-close="hiddenView" width="62%">
    <el-row>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-user"></i> 客户姓名</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.c_name }}</div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-time"></i> 提交时间</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.submited_time | unix2timestamp }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-location-information"></i> 国家</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.c_country }}</div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-paperclip"></i> 来源</div>
      </el-col>
      <el-col :span="9">
        <el-tooltip :content="detailData.url" placement="top">
          <!-- <el-button type="text" show-overflow-tooltip>{{ detailData.url }}</el-button> -->
          <el-link :underline="false" :href="detailData.url" target="_blank">{{ detailData.url | sliceUrl }}</el-link>
        </el-tooltip>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-message"></i> 客户邮箱</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.c_email }}</div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-wind-power"></i> 语种</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.language }}</div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-phone-outline"></i> 客户电话</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.c_tel }}</div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-map-location"></i> 客户IP</div>
      </el-col>
      <el-col :span="9">
        <el-tooltip content="点击查看IP地址" placement="top">
          <!-- <el-button type="text" show-overflow-tooltip>{{ detailData.url }}</el-button> -->
          <el-link :underline="false" :href="'https://www.baidu.com/s?wd=' + detailData.ip" target="_blank">{{ detailData.ip }}</el-link>
        </el-tooltip>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-box"></i> 需求产品</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.product }}</div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-s-platform"></i> 用户设备</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.device }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-coin"></i> 解决方案</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.solution }}</div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-monitor"></i> 浏览器</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.browser }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-set-up"></i> 分组</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.group_tag }}</div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-discount"></i> 询盘状态</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.c_state | stateShowFilter }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-s-custom"></i> 所属人</div>
      </el-col>
      <el-col :span="9">
        <!-- detailData.owner 或者 detailData.d_owner  -->
        <div class="grid-content">{{ showOwner }}</div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-s-check"></i> 处理人</div>
      </el-col>
      <el-col :span="9">
        <div class="grid-content">{{ detailData.operator }} @ {{ detailData.operate_time | unix2timestamp }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" style="height: 118px;line-height:120px">
        <div class="grid-content"><i class="el-icon-chat-round"></i> 消息内容</div>
      </el-col>
      <el-col :span="21" style="height: 118px;padding-left:0;">
        <el-input v-model="detailData.message" type="textarea"></el-input>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3">
        <div class="grid-content"><i class="el-icon-s-operation"></i> 询盘处理</div>
      </el-col>
      <el-col :span="21">
        <div class="grid-content">
          <el-radio-group v-model="radio">
            <el-radio :label="1">有效</el-radio>
            <el-radio :label="2">重复</el-radio>
            <el-radio :label="3">无效</el-radio>
            <el-radio :label="9">删除</el-radio>
          </el-radio-group>
          <el-button type="primary" size="small" icon="el-icon-edit-outline" style="margin-left:100px;" @click="reviewInquiryInfo">确认处理</el-button>
          <!-- <el-button type="primary" size="small" style="margin-right:60px;">复制信息</el-button> -->
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="text-align: right">
        <el-link v-clipboard:copy="copyData" v-clipboard:success="clipboardSuccess" icon="el-icon-document-copy" :underline="false" style="margin-right: 60px">复制本信息</el-link>
        <el-link :underline="false" icon="el-icon-back" style="margin-right: 20px" @click="getPrevious">上一条</el-link>
        <el-link :underline="false" style="margin-right: 10px" @click="getNext">下一条 <i class="el-icon-right"></i></el-link>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import clipboard from "@/directive/clipboard/index.js" // use clipboard by v-directive
import { reviewInquiry, deleteInquiry, getNeighbourById } from "@/api/inquiry"
export default {
  name: "DetailView",
  directives: {
    clipboard
  },
  filters: {
    sliceUrl(value) {
      if (!value) return ""
      if (value.length > 44) {
        return value.slice(0, 44) + "..."
      }
      return value
    },
    unix2timestamp(value) {
      if (!value) return null
      let date = new Date(parseInt(value) * 1000)
      let Y = date.getFullYear() + "-"
      let M = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) + "-" : date.getMonth() + 1 + "-"
      let D = date.getDate() < 10 ? "0" + date.getDate() + " " : date.getDate() + " "
      let h = date.getHours() < 10 ? "0" + date.getHours() + ":" : date.getHours() + ":"
      let m = date.getMinutes() < 10 ? "0" + date.getMinutes() + ":" : date.getMinutes() + ":"
      let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    stateShowFilter(status) {
      const stateShowMap = {
        0: "未处理",
        1: "有效",
        2: "重复",
        3: "无效"
      }
      return stateShowMap[status]
    }
  },
  data() {
    return {
      dialogTableVisible: false,
      radio: 0,
      textarea: ""
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object,
      default: null
    }
  },
  computed: {
    copyData: function() {
      return (
        "客户姓名: " +
        this.detailData.c_name +
        "\r\n" +
        "国家: " +
        this.detailData.c_country +
        "\r\n" +
        "客户邮箱: " +
        this.detailData.c_email +
        "\r\n" +
        "客户电话: " +
        this.detailData.c_tel +
        "\r\n" +
        "需求产品: " +
        this.detailData.product +
        "\r\n" +
        "解决方案: " +
        this.detailData.solution +
        "\r\n" +
        "消息内容: " +
        "\r\n" +
        this.detailData.message
      )
    },
    showOwner: function() {
      return this.detailData.group_tag === "留言板" ? (this.detailData.d_owner === null ? "未分配" : this.detailData.d_owner) : this.detailData.owner
    }
  },
  watch: {
    show: {
      handler(newVal) {
        this.dialogTableVisible = newVal
      },
      //初始值时也执行赋值动作
      immediate: true
    }
  },
  methods: {
    clipboardSuccess() {
      this.$message({
        message: "复制成功",
        type: "success",
        duration: 1500
      })
    },
    hiddenView() {
      this.$emit("close")
    },
    refetchData() {
      this.$emit("refreshFetchData")
    },
    handleDeleteInquiry(tempData) {
      this.$confirm("此操作将永久删除这一条 [" + tempData["group_tag"] + "] 信息， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteInquiry(tempData).then(res => {
            if (res.type === "success") {
              this.hiddenView()
              this.refetchData()
              this.radio = 0
            }
            this.$notify({
              message: res.message,
              type: res.type
            })
            this.radio = 0
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          })
        })
    },
    reviewInquiryInfo() {
      const reviewSelectionId = parseInt(this.radio)
      if (reviewSelectionId === 9) {
        const tempData = {
          inquiry_id: this.detailData["c_id"],
          group_tag: this.detailData["group_tag"]
        }
        this.handleDeleteInquiry(tempData)
        return
      }
      //这里不应该在这里直接修改父组件传过来的数据，虽然数组和对象类型不会报错，但如果父组件下边有多个子组件，就会
      //搞不清楚到底是哪个子组件修改了值
      //this.detailData["state"] = reviewSelectionId

      reviewInquiry(this.detailData, reviewSelectionId).then(res => {
        //this.detailData = res.data
        console.log(res.data)
        this.$emit("refreshStatus", res.data)
        //刷新一下
        this.refetchData()
        this.radio = 0
        //this.dialogTableVisible = false
        this.$message({
          type: res.type,
          message: res.message
        })
      })
    },
    getPrevious() {
      const itemId = parseInt(this.detailData["c_id"])
      const InquiryId = {
        inquiry_id: itemId,
        label: "previous"
      }
      getNeighbourById(InquiryId).then(res => {
        if (!res.item) {
          this.$message({
            type: res.type,
            message: res.message
          })
        } else {
          this.$emit("refreshStatus", res.item)
        }
      })
    },
    getNext() {
      const itemId = parseInt(this.detailData["c_id"])
      const InquiryId = {
        inquiry_id: itemId,
        label: "next"
      }
      getNeighbourById(InquiryId).then(res => {
        if (!res.item) {
          this.$message({
            type: res.type,
            message: res.message
          })
        } else {
          this.$emit("refreshStatus", res.item)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.el-row {
  .el-col {
    line-height: 40px;
    border: 1px solid #c2c2c2;
    border-bottom: none;
    padding-left: 10px;
  }
  // margin-bottom: 20px;
  // background: #f1f1f1;
  .el-col:nth-child(3) {
    border-left: none;
  }
  &:nth-child(odd) {
    background: #fafafa;
  }
  .el-col:nth-child(even) {
    border-left: none;
  }
  &:last-child {
    margin-bottom: 20px;
    .el-col {
      border-bottom: 1px solid #c2c2c2;
    }
  }
  ::v-deep textarea {
    height: 104px;
    border: none;
  }
}
</style>
